import { render } from "./charge_consumables_set.vue?vue&type=template&id=50804be3"
import script from "./charge_consumables_set.vue?vue&type=script&lang=js"
export * from "./charge_consumables_set.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__